import React, { useState } from 'react';
import { Modal, message } from 'antd';
import { api } from 'api';
import { getErrorMessage } from 'helpers/feedbackMessageHelper';

const DeleteLeagueModal = ({ open, onClose, league, onDeleted }) => {

    const [deleting, setDeleting] = useState(false);

    const handleDelete = async () => {
        setDeleting(true);
        try {
            await api.user.deleteMiniLeague(league.id);
            onClose();
            message.success(`${league.name} deleted`);
            onDeleted();
        } catch (error) {
            const errorMessage = error.response ? error.response.data.error : 'generic';
            message.error(getErrorMessage(errorMessage));
        }
        setDeleting(false);
    };

    return (
        <Modal
            title="Delete League"
            open={open}
            onCancel={onClose}
            onOk={handleDelete}
            okText="Delete"
            okButtonProps={{ danger: true }}
            confirmLoading={deleting}
        >
            Are you sure you want to delete <strong>{league?.name}</strong>? This cannot be undone.
        </Modal>
    );
};

export default DeleteLeagueModal;
